class FAQSearch {
  constructor() {
    this.searchBox = document.getElementById('searchbox');
    this.questions = document.querySelectorAll('.faq-question');
    this.categories = document.querySelectorAll('.faq-category');
    this.resultCount = document.querySelector('.customer-service__search-results');
    this.clearButton = document.querySelector('.search__clear');
    this.accordions = document.querySelectorAll('dt');
    this.faqAccordion = document.querySelector('.faqAccordion');

    this.stopwords = new Set(['a', 'an', 'and', 'are', 'as', 'at', 'be', 'by', 'for', 'from', 'has', 'he', 'in', 'is', 'it',
      'its', 'of', 'on', 'that', 'the', 'to', 'was', 'were', 'will', 'with']);

    this.bindEvents();
    this.initializeSearch();
  }

  bindEvents() {
    this.searchBox.addEventListener('input', this.debounce(this.search.bind(this), 800));
    this.clearButton.addEventListener('click', this.clear.bind(this));
  }

  initializeSearch() {
    const searchQuery = window.location.search;
    if (searchQuery) {
      const query = searchQuery.replace('?q=', '').replace(/\+/g, ' ');
      this.searchBox.value = query;
      this.search();
    }
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  removeStopwords(words) {
    // Use the stopword library if available, otherwise use the fallback method
    if (typeof stopword !== 'undefined' && typeof stopword.removeStopwords === 'function') {
      return stopword.removeStopwords(words);
    } else {
      return words.filter(word => !this.stopwords.has(word.toLowerCase()));
    }
  }

  search() {
    const searchArray = this.searchBox.value.toLowerCase().split(' ');
    const condensedSearchArray = this.removeStopwords(searchArray);
    const searchTerms = condensedSearchArray.join('|');
    const searchParameters = new RegExp(searchTerms, 'i');

    this.clearButton.classList.remove('u-hidden');

    if (typeof Mark === 'function') {
      const instance = new Mark(this.faqAccordion);
      instance.unmark();
    }

    let visibleResults = 0;

    this.categories.forEach(category => {
      let categoryVisible = false;

      const questions = category.querySelectorAll('.faq-question');
      questions.forEach(faq => {
        const questionText = faq.querySelector('dt button').innerText;
        const answerText = faq.querySelector('dd').innerText;

        if (searchParameters.test(questionText) || searchParameters.test(answerText)) {
          faq.classList.remove('u-hidden');
          faq.querySelector('dt button').setAttribute('aria-expanded', 'true');
          faq.querySelector('dd').style.display = 'block';
          if (typeof Mark === 'function') {
            new Mark(faq).mark(condensedSearchArray);
          }
          categoryVisible = true;
          visibleResults++;
        } else {
          faq.classList.add('u-hidden');
          faq.querySelector('dt button').setAttribute('aria-expanded', 'false');
          faq.querySelector('dd').style.display = 'none';
        }
      });

      if (categoryVisible) {
        category.classList.remove('u-hidden');
      } else {
        category.classList.add('u-hidden');
      }
    });

    this.updateCategoryResults();

    if (this.searchBox.value.length > 0) {
      this.resultCount.innerText = `${visibleResults} ${visibleResults !== 1 ? 'results' : 'result'} found for "${this.searchBox.value}"`;
    } else {
      this.resultCount.innerText = '';
      this.clear(); // Show all questions and categories if search is empty
    }
  }

  clear() {
    this.searchBox.value = '';
    this.clearButton.classList.add('u-hidden');
    this.resultCount.innerText = '';

    this.questions.forEach(question => {
      question.classList.remove('u-hidden');
      question.querySelector('dt button').setAttribute('aria-expanded', 'false');
      question.querySelector('dd').style.display = 'none';
    });

    this.categories.forEach(category => category.classList.remove('u-hidden'));

    if (typeof Mark === 'function') {
      new Mark(this.faqAccordion).unmark();
    }

    this.updateCategoryResults();
  }

  updateCategoryResults() {
    this.categories.forEach(category => {
      const categoryName = category.getAttribute('category-name');
      const activeEntries = category.querySelectorAll('.faq-question:not(.u-hidden)').length;

      const categoryHeader = document.querySelector(`h3[category-name="${categoryName}"]`);
      if (categoryHeader) {
        if (activeEntries === 0) {
          categoryHeader.classList.add('no-results');
        } else {
          categoryHeader.classList.remove('no-results');
        }

        const categoryQuestionCount = categoryHeader.querySelector('span span');
        if (categoryQuestionCount) {
          categoryQuestionCount.innerText = activeEntries;
        }
      }

      const categoryMobileHeader = document.querySelector(`div[category-name="${categoryName}"] h2 span span`);
      if (categoryMobileHeader) {
        categoryMobileHeader.innerText = activeEntries;
      }
    });
  }

  clear() {
    this.searchBox.value = '';
    this.clearButton.classList.add('u-hidden');
    this.resultCount.innerText = '';
    this.questions.forEach(question => question.classList.remove('u-hidden'));
    this.categories.forEach(category => category.classList.remove('u-hidden'));

    if (typeof Mark === 'function') {
      new Mark(this.faqAccordion).unmark();
    }

    this.updateCategoryResults();
  }
}

// Initialize the FAQSearch when the DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new FAQSearch();
});
